export const skillData = [
    {
        displayName: "React",
        imgSource: "./data/icons/react.svg",
        link: "https://reactjs.org/",
    },
    {
        displayName: "Redux",
        imgSource: "./data/icons/redux.png",
        link: "https://redux.js.org/",
    },
    {
        displayName: "GraphQL",
        imgSource: "./data/icons/graphql.png",
        link: "https://graphql.org/",
    },
    {
      displayName: "React Native",
      imgSource: "./data/icons/react_native.png",
      link: "https://reactnative.dev/",
    },
    {
        displayName: "Agile",
        imgSource: "./data/icons/agile.png",
        link: "https://agilemanifesto.org/",
    },
    {
        displayName: "HTML5",
        imgSource: "./data/icons/html.png",
        link: "https://developer.mozilla.org/en-US/docs/Glossary/HTML5",
    },
    {
        displayName: "Git",
        imgSource: "./data/icons/git.png",
        link: "https://git-scm.com/",
    },
    {
        displayName: "Ruby",
        imgSource: "./data/icons/ruby.png",
        link: "https://www.ruby-lang.org/",
    },
    {
        displayName: "Rails",
        imgSource: "./data/icons/rails.png",
        link: "https://rubyonrails.org/",
    },
    {
        displayName: "RSpec",
        imgSource: "./data/icons/rspec.png",
        link: "https://rspec.info/",
    },
    {
        displayName: "Python",
        imgSource: "./data/icons/python.png",
        link: "https://www.python.org/",
    },
    {
        displayName: "PostGres",
        imgSource: "./data/icons/postgresql.png",
        link: "https://www.postgresql.org/",
    },
]
